var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.field.field.clickAction &&
    _vm.field.field.clickAction.optionsComponent
    ? _c(_vm.field.field.clickAction.optionsComponent, {
        tag: "component",
        attrs: { value: _vm.value },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }